import FooterIntro from './FooterIntro';

export default FooterIntro;